import { Modal as AntdModal, ModalProps } from 'antd';
import { FC } from 'react';
import { XCircleFill } from 'react-bootstrap-icons';

import { AppModalControlProps } from '@/common/interfaces';

import './AppModal.scss';

interface Props extends Omit<ModalProps, 'open' | 'closeIcon' | 'destroyOnClose' | 'onCancel' | 'onClose'> {
  controls: AppModalControlProps;
}

export const AppModal: FC<Props> = ({
  children,
  controls,
  className,
  zIndex,
  ...otherProps
}: Props) => {
  const handleClose = () => {
    controls.close();
  };

  return (
    <AntdModal
      { ...otherProps }
      className={ `app-modal ${ className || '' }` }
      closeIcon={ <XCircleFill size={ 20 }/> }
      destroyOnHidden
      onCancel={ handleClose }
      open={ controls.isOpen }
      zIndex={ zIndex ?? 1071 }
    >
      { children }
    </AntdModal>
  );
};
